const emptyMetrics = {
    onlineUsage: [],
    repairValue: [],
    pmCompletion: [],
    workRetention: []
};

const isValidParsedDate = date => {
    return date instanceof Date && Number.isFinite(date.getTime());
};

const isValidPercentage = percentage => Number.isFinite(percentage) && percentage >= 0 && percentage <= 100;

const parseMetricDate = (parseTime, date) => {
    try {
        return parseTime(date);
    } catch {
        return null;
    }
};

const normalizeMetricRows = (rows, parseTime) => {
    return (Array.isArray(rows) ? rows : [])
        .filter(d => d)
        .map(d => {
            const percentage = typeof d.percentage === 'number'
                ? d.percentage
                : typeof d.percentage === 'string' && d.percentage.trim() !== ''
                    ? Number(d.percentage)
                    : NaN;

            return {
                ...d,
                date: parseMetricDate(parseTime, d.date),
                percentage
            };
        })
        .filter(d => isValidParsedDate(d.date) && isValidPercentage(d.percentage))
        .sort((a, b) => {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return 0;
        });
};

const normalizeGamificationData = (serverData, parseTime) => {
    const data = serverData || {};

    return Object.keys(emptyMetrics).reduce((result, metricName) => {
        result[metricName] = normalizeMetricRows(data[metricName], parseTime);
        return result;
    }, {});
};

module.exports = {
    isValidParsedDate,
    normalizeGamificationData,
    normalizeMetricRows
};
